import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { TermCategoryRow } from '@models/term/termCategory';
import { Link } from '@router/Link';

import styles from './styles.module.scss';

interface Props {
    termCategory: TermCategoryRow;
}

function PolicyRow({ termCategory }: Props) {
  const { title, id } = termCategory;
  return (
        <Row fullWidth justify='space-between'
             align='center'
             className={styles.container}>
            <Text size='lg' color={colors.gray7}>{title}</Text>
            <Link activityName='TermDetailActivity'
                  activityParams={{ termCategoryId: id }} >
                <Text color={colors.primary}
                      fontWeight='medium'
                      className={styles.link} >
                    보기
                </Text>
            </Link>
        </Row>
  );
}

export default PolicyRow;
